import React, { useState, useEffect } from 'react';
import API_URLS from '../summaryapi/apiUrls'; // Assuming you have imported the API_URLS file correctly
import './ProviderProfile.css'; // Assuming you will add custom CSS for styling
import { toast } from 'react-toastify'; // Import the toast notification function
import 'react-toastify/dist/ReactToastify.css'; 
import { RingLoader } from 'react-spinners';
const ProviderProfile = () => {
  const [provider, setProvider] = useState(null);
  const [formData, setFormData] = useState({
    provider_id: '',
    category_id: '',
    name: '',
    email: '',
    mobile_number: '',
    address: '',
    latitude: '',
    longitude: '',
    is_available: '',
    is_active: '',
    created_date: '',
    category_name: ''
  });


  const [loading, setLoading] = useState(true);
  // Get provider data from session storage and decode provider_id
  useEffect(() => {
    
    const encodedProviderId = sessionStorage.getItem('provider_id');
    if (encodedProviderId) {
      const providerId = atob(encodedProviderId); // Decode the provider ID

      // Fetch provider data using the providerId
      const fetchProviderData = async () => {
        setLoading(true);
        try {
          // Pass providerId and other required data using JSON.stringify in the request body
          const response = await fetch(API_URLS.getProviderDetailsProfile.url, {
            method: API_URLS.getProviderDetailsProfile.method, // Use POST or PUT depending on your API
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ provider_id: providerId }) // Sending provider_id as part of the request body
          });
          
          const data = await response.json(); // Updated to .json() as .data is incorrect
          
          if (data.status && data.data) {
            const providerData = data.data;
            setProvider(providerData);
            setFormData({
              provider_id: providerData.provider_id,
              category_id: providerData.category_id,
              name: providerData.name,
              email: providerData.email,
              mobile_number: providerData.mobile_number,
              address: providerData.address,
              latitude: providerData.latitude,
              longitude: providerData.longitude,
              is_available: providerData.is_available,
              is_active: providerData.is_active,
              created_date: providerData.created_date,
              category_name: providerData.category_name
            });
          } else {
            console.error('Provider data not found');
          }
        } catch (error) {
          console.error('Error fetching provider data:', error);
        }
      };
      
      fetchProviderData();
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };


  if (loading) {
    return (
      <div>
        <h3 style={{color: '#8A2BE2'}}>Loading Provider Details...</h3>
        <RingLoader color="#3498db" loading={loading} size={50} />
      </div>
    );
  }
  const handleUpdate = async () => {
    // Validate the email format using regex
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      return; // Prevent the update if the email is invalid
    }
  
    try {
      // Send the update request to the API
      const response = await fetch(API_URLS.updateProviderDetails.url, {
        method: API_URLS.updateProviderDetails.method, // POST or PUT depending on your API
        headers: {
          'Content-Type': 'application/json' // Ensure the body is sent as JSON
        },
        body: JSON.stringify(formData) // Sending the updated form data as JSON
      });
  
      // Parse the response JSON
      const data = await response.json();
  
      // Check if the response success is true
      if (data.success) {
        toast.success(data.message); // Show success toast with the message from backend
      } else {
        toast.error('Failed to update profile'); // Show error toast if update failed
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error('An error occurred while updating the profile'); // Show error toast on fetch error
    }
  };
  
  return (
    <div>
      <h2 style={{color: '#8A2BE2'}}>Provider Profile</h2>
      <div className="provider-profile">
      <form onSubmit={(e) => e.preventDefault()} className="provider-form">
      <div className="form-group hidden-provider-id">
  <label>Provider ID</label>
  <input
    type="text"
    value={formData.provider_id}
    readOnly
    disabled
  />
</div>
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Mobile Number</label>
          <input
            type="text"
            name="mobile_number"
            value={formData.mobile_number}
            readOnly
            disabled
          />
        </div>
        <div className="form-group">
          <label>Address</label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Category</label>
          <input
            type="text"
            name="category_name"
            value={formData.category_name}
            readOnly
            disabled
          />
        </div>
        <div className="form-group">
          <label>Availability</label>
          <select
            name="is_available"
            value={formData.is_available}
            onChange={handleChange}
          >
            <option value="1">Available</option>
            <option value="0">Not Available</option>
          </select>
        </div>
        <div className="form-group">
          <label>Status</label>
          <select
            name="is_active"
            value={formData.is_active}
            onChange={handleChange}
          >
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </div>
<div className='text-center'>
        <button
          type="button"
          className="update-button"
          onClick={handleUpdate}
        >
          Update
        </button></div>
      </form>
    </div>    </div>
  );
};

export default ProviderProfile;
